<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/info-pool?id=4">信息交流</router-link></li>
                <li class="currentNode"><a>{{ title }}</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>信息交流</a></li>
                    <li><router-link to="/layout/info-pool?id=4" :class="{'active': id === '4'}">每日信息</router-link></li>
                    <li><router-link to="/layout/share-info?id=2" :class="{'active': id === '2'}">共享信息</router-link></li>
                    <li><router-link to="/layout/info-pool?id=3" :class="{'active': id === '3'}">专报信息</router-link></li>
                    <li><router-link to="/layout/info-pool?id=1" :class="{'active': id === '1'}">智库信息</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>{{ title }}</h3>
                    <ul class="share-info-list">
                        <li class="share-data" v-for="shareInfo in shareInfoList" :key="shareInfo.ProjectId">
                            <h4 class="group_title">
                                <span>{{ shareInfo.zhujingbanName }}</span>
                                <router-link :to="{
                                    path:'/layout/share-info-item',
                                    query:{
                                        id:id,
                                        officeId: shareInfo.zhujingbanId,
                                        officeName:shareInfo.zhujingbanName,
                                        parentPage: currentPage
                                    }}">更多 ></router-link>
                            </h4>
                            <!-- <p class="ellipsis_four">{{ infoPool.ProjectDesc }}</p> -->
                            <ul class="share-data-bar">
                                <li v-for="item in  shareInfo.lstGongXiang" :key="item.Id">
                                    <router-link  :to="{
                                        path:'/layout/share-info-item-detail',
                                        query:{
                                            id:item.Id,
                                            officeId: shareInfo.zhujingbanId,
                                            parentPage: currentPage,
                                            officeName: shareInfo.zhujingbanName,
                                            }}"  class="share-data-bar-item">
                                        <p class="content ellipsis_one">
                                            <span class="dot"></span>
                                            <!-- <span>吃呢就的顶焦度计顶焦度计经济的角度讲吃呢就的顶焦度计顶焦度计经济的角度讲</span> -->
                                            <span>{{ item.Title }}</span>
                                        </p>
                                        <p class="date">{{ item.UpdateTime }}</p>
                                    </router-link>
                                </li>
                                 <!-- <li class="share-data-bar-item">
                                       <p class="content ellipsis_one">
                                            <span class="dot"></span>
                                            <span>吃呢就的顶焦度计顶焦度计经济的角度讲</span>
                                        </p>
                                        <p class="date">2024-10-02</p>
                                    </li>
                                    <li class="share-data-bar-item">
                                        <p class="content ellipsis_one">
                                            <span class="dot"></span>
                                            <span>吃呢就的顶焦度计顶焦度计经济的角度讲</span>
                                        </p>
                                        <p class="date">2024-10-02</p>
                                    </li> -->
                            </ul>   
                        </li>
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getGongxiang,
    getProjectDown
} from '@services/indexService.js'
export default {
    name: '',
    data() {
        return {
            downloadUrl: "",
            id: "",// 所有0，智库信息1，批示专报信息2，专报信息3，一般信息4
            title: "",    
            shareInfoList:[],
            total: 0,
            currentPage: 1,
            pageSize: 10,        
        };
    },
    created() {
        this.id = this.$route.query.id;
        if (this.$route.query.parentPage) {
            this.currentPage = Number(this.$route.query.parentPage);
        }
        this.traverseTitle();
        this.getGongxiang();
    },
    methods: {
        traverseTitle() {
            console.log(this.id);
            if (this.id === '1'){
                this.title = "智库信息";
            } else if (this.id === '2') {
                this.title = "共享信息";
            }else if (this.id === '3') {
                this.title = "专报信息";
            } else {
                this.title = "每日信息";
            }
        },
        getGongxiang() {   
            getGongxiang({current: this.currentPage, size: this.pageSize}).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.shareInfoList = [...res.Data];
                    this.total = res.Count;
                    this.shareInfoList.map(item => {
                        if(item.lstGongXiang.length > 3) {
                            item.lstGongXiang = item.lstGongXiang.slice(0,3);
                        }
                        return item;
                        
                    })
                } else {
                    this.$message.error("共享信息请求失败");
                }
            })
        },
        
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getGongxiang();
        },
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + "";
                // this.getProjectList()
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
};
</script>

<style scoped>
.page-content {
    padding: 30px 40px;
}
.page-content h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.share-info-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top:20px;
    padding-bottom: 10px;
}
.share-data {
    width: 456px;
    border: 1px solid #E5E5E5;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 20px;
    height: 168px;
    box-sizing: border-box;
}
.share-data h4 {
    height: 30px;
}
.share-data h4 span {
    height: 30px;
    background: none;
}
.share-data .group_title {
    margin-bottom: 0;
}
.share-data .group_title span{
    height: 45px;
    background: none;
    font-size: 18px;
    color: #262626;
    width: auto;
    border-bottom: none;
    padding: 0;
}
.share-info-list .share-data:nth-child(2n) {
    margin-right: 0px;
}
.share-data-bar {
    padding-top: 5px;
}
.share-data-bar-item {
    width: 100%;
    color: #1D2129;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    padding-top: 20px;
    padding-right:5px;
    height: 30px;
}
.share-data-bar-item p{
    font-family: 思源黑体 CN;
    font-size: 14px;
    line-height: 19.2px;
    color:#4E5969;
}
.share-data-bar-item:hover p{
    color: #116EBA;
}
.share-data-bar-item:hover .dot{
    background:#116EBA;
}
.share-data-bar-item .content {
    width: 316px;
    flex-shrink: 0;
}
.share-data-bar-item .content span {
  vertical-align: middle;
}
</style>